/**
 * @function checkWebGL
 * @desc Check if webGL is supported by graphic card or browser
 */
const checkWebGL = () => {
  try {
    const canvas = document.createElement('canvas')
    if (!window.WebGLRenderingContext || !canvas.getContext) return false
    return window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl'))
  } catch (e) {
    return false
  }
}

export default checkWebGL
